import { render, staticRenderFns } from "./CardDescriptionWithCTA.vue?vue&type=template&id=7faa5f8c&scoped=true&"
import script from "./CardDescriptionWithCTA.vue?vue&type=script&lang=js&"
export * from "./CardDescriptionWithCTA.vue?vue&type=script&lang=js&"
import style0 from "./CardDescriptionWithCTA.vue?vue&type=style&index=0&id=7faa5f8c&lang=scss&scoped=true&"
import style1 from "./CardDescriptionWithCTA.vue?vue&type=style&index=1&id=7faa5f8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7faa5f8c",
  null
  
)

export default component.exports